module.exports = __webpack_public_path__ + "img/ebay-logo.af6be8e7.svg";